import { IState } from 'shared/store';

export const selectReviewStats = (state: IState) => {
  return state.offerData.company?.reviewStats;
};
